import React from 'react';
import Logo from "../assets/belleepoque_logo.png";

const OrganizationSchema = () => {
    const organizationData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Belle Epoque - Agência de Viagens",
        "url": "https://belle-epoque.pt",
        "logo": { Logo },
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+351935945664",
            "contactType": "Company",
            "areaServed": "PT",
            "availableLanguage": "English"
        },
        "sameAs": [
            "https://www.facebook.com/belleepoque2017",
            "https://www.instagram.com/belleepoqueviagens/",
            "https://www.linkedin.com/company/belle-epoque-viagens-e-turismo/about/"
        ]
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationData) }}
        />
    );
};

export default OrganizationSchema;
